import { createI18n } from "vue-i18n";
import ru from "./locales/ru.json"
import en from "./locales/en.json"
import de from "./locales/de.json"
import es from "./locales/es.json"
import fr from "./locales/fr.json"
import it from "./locales/it.json"
import pl from "./locales/pl.json"
import pt from "./locales/pt.json"
import tr from "./locales/tr.json"
import ko from "./locales/ko.json"

export default createI18n({
    locale: localStorage.getItem('lang') || 'en', 
    fallbackLocale: 'ru', 
    legacy: false,
    globalInjection: true,
    messages: { 
        ru,
        en,
        de,
        es,
        fr,
        it,
        pl,
        pt,
        tr,
        ko
    },
    runtimeOnly: false,
})